module.exports = __webpack_public_path__ + "media/bootstrap-icons/flower2-7a9d5aa1.svg";